const customergroups = {
	title: "Kundegruppe",
	new_customergroup: "Ny kundegruppe",
	edit_customergroup: "Rediger: {name}",
	view_customergroup: "Vis: {name}",
	list_title: "Kundegruppe liste",
	list_subtitle: "Håndter kundegrupper",
	create_title: "Opprett ny kundegruppe",
	update_title: "Oppdater ny kundegruppe",
	id: "ID",
	name: "Navn",
	status: "Status",
	created_by: "Opprettet av",
};
export default customergroups;